import Animation from '../../animations/animation'
import Transformer from '../transformers/area-bar-transformer'

/*
 * This animation is used to take a serie that was previously
 * a bar and turn it into a line.
 */
class FromBarAnimation extends Animation {

  constructor (options) {
    super(options)

    this.ripple = this.chart.layout.breakdown.calculated ? false : true
  }

  match (serie) {
    if (!this.previous.allSerieTypes[serie.id]) {
      return false
    }
    return this.previous.allSerieTypes[serie.id].type === 'bar'
  }

  animate (serie, entering, selection, merged, exiting) {
    // Put the new area in the DOM at the correct position
    this._initialInsert(entering)

     // Don't show thew new area serie just yet
    entering.style('display', 'none')

    let bar = this.previous.allSerieTypes[serie.id].serie
      , transformer = new Transformer({
        serie: entering,
        previous: this.previous,
        scalers: this.scalers,
        yScale: this.yScale,
        splitWidth: this.serieScale.bandwidth(),
        areaScale: this.scalers,
        splitScale: d => {
          return this.scalers.x.groupScale(d.rangeId) + this.serieScale(serie._columnIdx)
        },
        styles: {
          area: {
            stroke: entering.selectAll('path.line.data-line').style('stroke'),
            lineStrokeWidth: this.styles.areaStroke,
            areaStrokeWidth: 0,
            fill: entering.selectAll('path.area').style('fill'),
            opacity: this.styles.areaOpacity
          },
          bar: {
            stroke: bar.selectAll('line').style('stroke'),
            lineStrokeWidth: bar.selectAll('line').style('stroke-width'),
            areaStrokeWidth: bar.selectAll('line').style('stroke-width'),
            fill: bar.selectAll('rect').style('fill'),
            opacity: 1
          }
        }
      })

    let splits = transformer.insert(1)

    bar.selectAll('.rect').remove()

    splits.transition()
          .delay(d => this.timing.delay(d._data))
          .duration(this.timing.duration)
          .tween('transform', function (d) {
            return t => {
              transformer.transform(1 - t, this)
            }
          })
          .end().then(() => {
            // We can now show the area
            entering.style('display', '') // Show the full area path
                    .selectAll('path').style('opacity', '') // Show paths

            splits.remove() // Remove the splits when done.
          }).catch(() => {
            // interrupted transition, ignore
          })
  }

}

export default FromBarAnimation
